function BodyText(props) {
    return <p className="black">{props.text}</p>;
}

export default BodyText;